/*
   Journey Step

   Show the art available for the given step
   Show the relative blurb for this step
   Allow the user to click on an art piece and show the selection modal
   Upon selection of the art piece, set the state and move to the next step

   http://jsfiddle.net/ThiefMaster/LPh33/4/
 */

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Artwork from './Artwork'
import ArtworkModal from './ArtworkModal'
import { 
  getSelectedJourney,
  getJourneyStepsForSelectedJourney,
  getCurrentJourneyStep,
  getArtworkForCurrentStep,
  artworkSelectionFinished,
} from '../../selectors/journeyState-selectors'
import { setJourneyNavStep } from '../../actions/journey-actions'
import Hammer from "react-hammerjs";
import { tapOptions } from '../../utils/hammerOptions';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import '../../css/JourneyStep.css'
import btnContinue from '../../assets/btn_continue.png'


class JourneyStep extends React.Component {
   render() {
      const { galleryId, getCurrentJourneyStep, 
         getArtworkForCurrentStep, artworkSelectionFinished,
         setJourneyNavStep } = this.props
      if (getCurrentJourneyStep === null || getCurrentJourneyStep === undefined) {
         return null
      }
      return   (
        getCurrentJourneyStep &&
         <span>
            <ReactCSSTransitionGroup
               transitionName="journeystep-transition"
               transitionAppear={true}
               transitionAppearTimeout={1000}
               transitionEnterTimeout={1000}
               transitionLeaveTimeout={1000}>
               <div className={'journeystep-title-container bordered-container'} key={`journeystep-${getCurrentJourneyStep.get('id')}`}>
                 <div 
                    className={'journeystep-title border'}>
                   <h1 className={'large-2'}>{getCurrentJourneyStep.get('name')}</h1>
                   <h2 className={'medium-1'}>{getCurrentJourneyStep.get('description')}</h2>
                 </div>
               </div>
            </ReactCSSTransitionGroup>
            {getArtworkForCurrentStep && 
              getArtworkForCurrentStep.map((a,i) => 

               <ReactCSSTransitionGroup
                  transitionName="artwork-transition"
                  transitionAppear={true}
                  transitionAppearTimeout={2500}
                  transitionEnterTimeout={2500} /* up to 1 full second delay + 1400ms transition time + 100ms buffer */
                  transitionLeaveTimeout={1500}>
                     <Artwork 
                        key={`${getCurrentJourneyStep.get('id')}-${a.id}`} 
                        index={i} 
                        artwork={a} 
                        galleryId={galleryId} />
               </ReactCSSTransitionGroup>
                )
            }
            <ArtworkModal galleryId={galleryId} />
              <ReactCSSTransitionGroup
                 transitionName="continue-button"
                 transitionAppear={true}
                 transitionAppearTimeout={2000}
                 transitionEnterTimeout={2000}
                 transitionLeaveTimeout={2000}>
                  {artworkSelectionFinished &&

                  <Hammer onTap={() => setJourneyNavStep(galleryId, 3)} options={tapOptions} >
                      <img className="continue" src={btnContinue} alt={'continue button'} />
                  </Hammer>
                  }
              </ReactCSSTransitionGroup>
         </span>
      );
   }
}

const mapStateToProps = (state, ownProps) => {
  return {
    selectedJourney: getSelectedJourney(state, ownProps),
    getJourneyStepsForSelectedJourney: getJourneyStepsForSelectedJourney(state, ownProps),
    getCurrentJourneyStep: getCurrentJourneyStep(state, ownProps),
    getArtworkForCurrentStep: getArtworkForCurrentStep(state, ownProps),
    artworkSelectionFinished: artworkSelectionFinished(state, ownProps),
    ...ownProps
  }
}
const mapDispatchToProps = dispatch => bindActionCreators({
  setJourneyNavStep
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JourneyStep)


// WEBPACK FOOTER //
// ./src/components/JourneyStep/JourneyStep.js